import React, { useEffect, useState } from "react";
import { PieChart, ColumnChart, BarChart, LineChart } from "react-chartkick";
import "chartkick/chart.js";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Libraries
import { motion } from "framer-motion";

import axios from "axios";

// Components
import DisputePageTitle from "../Components/DisputePageTitle";
import DisputesHeaderDark from "../Components/DisputesHeaderDark";
// import { Container } from "react-bootstrap";
import DisputesFooter from "../Components/DisputesFooter";

Chart.register(ChartDataLabels);

const getAdjudicators = async (setAdjudicators, setError, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}adjudicators/`
    );

    setAdjudicators(response.data);
  } catch (error) {
    setError(true);
    console.log(error);
  } finally {
    setLoading(false);
  }
};

const getSheetValues = async (setValues, setError, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}statistics/`
    );

    const formattedData = response.data.statistics.map((array, index) => {
      return { label: array[0]?.trim(), value: array[1] };
    });
    setValues(formattedData);
  } catch (error) {
    setError(true);
    console.log(error);
  } finally {
    setLoading(false);
  }
};

const Statistics = (props) => {
  const [values, setValues] = useState([]);
  const [adjudicators, setAdjudicators] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [years, setYears] = useState([]);

  const traineeAdj = adjudicators.filter((adj) => adj.type === 3);
  const traineeFem = traineeAdj.filter(
    (adj) => adj.gender.toUpperCase() === "F"
  );
  const traineeMal = traineeAdj.filter(
    (adj) => adj.gender.toUpperCase() === "M"
  );

  const adj = adjudicators.filter((adj) => adj.type === 2);
  const adjFem = adj.filter((adj) => adj.gender.toUpperCase() === "F");
  const adjMal = adj.filter((adj) => adj.gender.toUpperCase() === "M");

  const seniorAdj = adjudicators.filter((adj) => adj.type === 1);
  const seniorFem = seniorAdj.filter((adj) => adj.gender.toUpperCase() === "F");
  const seniorMal = seniorAdj.filter((adj) => adj.gender.toUpperCase() === "M");

  useEffect(() => {
    if (!values || values.length === 0) return;

    const yearsStart = values.findIndex(
      (item) => item.label === "" && item.value === "Filed:"
    );

    const yearsEnd = values.findIndex((item) => item.label === "TOTALS:");

    if (yearsStart === -1 || yearsEnd === -1 || yearsEnd < yearsStart) return;

    const years = values.slice(yearsStart + 1, yearsEnd);
    setYears(years);
  }, [values]);

  useEffect(() => {
    getSheetValues(setValues, setError, setLoading);
    getAdjudicators(setAdjudicators, setError, setLoading);
  }, []);

  return (
    <div style={props.style}>
      <DisputesHeaderDark />
      <DisputePageTitle title="Statistics" />
      <section className="pb-[160px] overflow-hidden cover-background lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px] min-h-screen">
        {error && (
          <motion.div
            initial={{
              scale: 0.8,
              opacity: 0,
            }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{
              duration: 0.3,
              ease: "easeOut",
            }}
          >
            {error && (
              <div
                className="my-3 p-3 rounded text-danger"
                style={{ border: "2px solid red" }}
              >
                Error fetching statistics!
              </div>
            )}
          </motion.div>
        )}

        {loading && <div className="cases loading"></div>}

        {!loading && !error && (
          <>
            <div className="m-5 row justify-content-center bg-lightgray border">
              {/* CASE OUTCOMES */}
              <div className="col-12 relative flex align-items-center justify-content-center p-5 mb-5">
                <p className="absolute xl:left-[47%] xl:top-[45%] md:invisible sm:invisible text-[#ef8d23] text-[3rem] font-bold">
                  <span className="text-[1rem] block text-dark">Total</span>

                  {
                    values.find(
                      (value) =>
                        value.label ===
                        "Total Cases Filed"
                    )?.value
                  }
                </p>
                <PieChart
                  height="400px"
                  data={[
                    [
                      "Settled",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Number of Cases Settled"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "IM Settled",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Number of Cases IM Settled"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Withdrawn",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Number of Cases Withdrawn"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Pending",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Number of Cases Pending"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Decided",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Number of Cases Decided"
                        )?.value
                      ) || 0,
                    ],

                  ]}
                  colors={[
                    "#000000",
                    "#464545",
                    "#f26419",
                    "#cccccc",
                    "rgba(239, 141, 35, 1)",
                  ]}
                  library={{
                    cutout: "50%",
                    plugins: {
                      datalabels: {
                        display: false,
                      },

                      title: {
                        display: true,
                        text: "Case Outcomes",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                      legend: {
                        display: true,
                        position: "bottom",
                        align: "left",

                        labels: {
                          padding: 40,
                        },

                        // labels: {
                        //   boxWidth: 13,
                        //   boxHeight: 13,
                        //   borderRadius: 2,
                        //   usePointStyle: false,
                        //   generateLabels: (chart) => {
                        //     const data = chart.data;
                        //     if (data.labels.length) {
                        //       return data.labels.map((label, i) => {
                        //         const value = data.datasets[0].data[i];
                        //         const paddedLabel = `${label}: ${value}`.padEnd(
                        //           50,
                        //           " "
                        //         );
                        //         return {
                        //           text: paddedLabel,
                        //           fillStyle:
                        //             data.datasets[0].backgroundColor[i],
                        //           strokeStyle: "#ffffff",
                        //           lineWidth: 2,
                        //           hidden: isNaN(value) || value === 0,
                        //           index: i,
                        //         };
                        //       });
                        //     }
                        //     return [];
                        //   },
                        // },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
            </div>
            <div className="mx-5 mb-4">
              <div className="border p-5">
                <LineChart
                  data={years.reduce((acc, curr) => {
                    acc[curr.label] = curr.value;
                    return acc;
                  }, {})}
                  height="300px"
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    cutout: "50%",
                    plugins: {
                      datalabels: {
                        display: true,
                        anchor: "end",
                        align: "end",
                      },

                      title: {
                        display: true,
                        text: "Cases Per Year",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                  }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 xs:grid-cols-1 gap-4  p-5 pt-0 ">
              {" "}
              {/* OPPOSED VS UNOPPOSED CASES */}
              <div className="relative border flex align-items-center justify-content-center p-5">
                {/* <p className="absolute xl:left-[30%] xl:top-[50%] sm:left-[16%] sm:top-[50%] text-[rgba(239, 141, 35, 1)] text-[3rem] font-bold">
                  Total <br />
                  <br />{" "}
                  {
                    values.find(
                      (value) =>
                        value.label ===
                        "Total number of opposed and unopposed cases"
                    )?.value
                  }
                </p> */}
                <ColumnChart
                  height="300px"
                  data={[
                    [
                      "Opposed Complaints",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Opposed Complaints"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Unopposed Complaints",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Unopposed Complaints"
                        )?.value
                      ) || 0,
                    ],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },

                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "end",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: Math.round, // or (value) => `${value} pts`
                      },
                      title: {
                        display: true,
                        text: "Complaint Opposition",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
              {/* DISPUTE SUCCESS */}
              <div className="relative border flex align-items-center justify-content-center p-5">
                <ColumnChart
                  height="300px"
                  data={[
                    [
                      "Successful Disputes",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Successful Complaints"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Unsuccessful Disputes",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Refused Complaints"
                        )?.value
                      ) || 0,
                    ],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },
                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "end",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Dispute Success",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
              {/* OPPOSED CASES */}
              <div className="relative border flex align-items-center justify-content-center p-5">
                <BarChart
                  height="300px"
                  data={[
                    [
                      "Lead to a Refusal",
                      parseFloat(
                        values.find(
                          (value) =>
                            value.label ===
                            "Opposed Refused Complaints"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Lead to a Transfer",
                      parseFloat(
                        values.find(
                          (value) =>
                            value.label ===
                            "Opposed Successful Complaints"
                        )?.value
                      ) || 0,
                    ],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },
                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "right",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Opposed Cases",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
              {/* UNOPPOSED CASES */}
              <div className="relative border flex align-items-center justify-content-center p-5">
                {/*  */}
                <BarChart
                  height="300px"
                  data={[
                    [
                      "Lead to a Refusal",
                      parseFloat(
                        values.find(
                          (value) =>
                            value.label ===
                            "Unopposed Refused Complaints"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Lead to a Transfer",
                      parseFloat(
                        values.find(
                          (value) =>
                            value.label ===
                            "Unopposed Successful Complaints"
                        )?.value
                      ) || 0,
                    ],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },
                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "right",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Unopposed Cases",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
              {/* INFORMAL MEDIATION */}
              <div className="relative border flex align-items-center justify-content-center p-5">
                <BarChart
                  height="300px"
                  data={[
                    [
                      "Successful",
                      parseFloat(
                        values.find(
                          (value) =>
                            value.label ===
                            "Successful Informal Mediation (IM)"
                        )?.value
                      ) || 0,
                    ],
                    [
                      "Unsuccessful",
                      parseFloat(
                        values.find(
                          (value) =>
                            value.label ===
                            "Unsuccessful Informal Mediation (IM)"
                        )?.value
                      ) || 0,
                    ],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },
                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "right",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Informal Mediation",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
              {/* APPEALED */}
              <div className="relative border flex align-items-center justify-content-center p-5">
                <BarChart
                  height="300px"
                  data={[
                    [
                      "Appealed Cases",
                      parseFloat(
                        values.find(
                          (value) => value.label === "Number of Cases Appealed"
                        )?.value
                      ) || 0,
                    ],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },

                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "right",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Appealed Cases",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
            </div>

            <div className="mx-5 row justify-content-center pb-5 bg-lightgray mb-5 border">
              <div className="col-12 relative flex align-items-center justify-content-center p-5">
                <p className="absolute xl:left-[47%] xl:top-[45%] md:invisible sm:invisible text-[#ef8d23] text-[3rem] font-bold">
                  <span className="text-[1rem] block text-dark">Total</span>

                  {adjudicators.length}
                </p>
                <PieChart
                  height="400px"
                  data={[
                    ["Trainee Adjudicators", traineeAdj.length],
                    ["Adjudicators", adj.length],
                    ["Senior Adjudicators", seniorAdj.length],
                  ]}
                  colors={[
                    "rgba(239, 141, 35, 1)",
                    "#000000",
                    "#464545",
                    "#f26419",
                    "#cccccc",
                  ]}
                  library={{
                    cutout: "50%",
                    plugins: {
                      datalabels: {
                        display: false,
                      },
                      legend: {
                        display: true,
                        position: "bottom",
                        align: "left",

                        labels: {
                          padding: 40,
                        },
                        // labels: {
                        //   boxWidth: 13,
                        //   boxHeight: 13,
                        //   borderRadius: 2,
                        //   usePointStyle: false,
                        //   generateLabels: (chart) => {
                        //     const data = chart.data;
                        //     if (data.labels.length) {
                        //       return data.labels.map((label, i) => {
                        //         const value = data.datasets[0].data[i];
                        //         const paddedLabel = `${label}: ${value}`.padEnd(
                        //           50,
                        //           " "
                        //         );

                        //         return {
                        //           text: `${label}: ${value}`,
                        //           fillStyle:
                        //             data.datasets[0].backgroundColor[i],
                        //           strokeStyle: "#ffffff",
                        //           lineWidth: 1,
                        //           hidden: isNaN(value) || value === 0,
                        //           index: i,
                        //         };
                        //       });
                        //     }
                        //     return [];
                        //   },
                        // },
                      },
                      title: {
                        display: true,
                        text: "Adjudicator Types",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 xs:grid-cols-1  gap-4 p-5 pt-0">
              <div className="relative border flex align-items-center justify-content-center p-5">
                <BarChart
                  height="300px"
                  data={[
                    ["Male", traineeMal.length],
                    ["Female", traineeFem.length],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    scales: {
                      x: {
                        suggestedMax:
                          traineeMal.length > traineeFem.length
                            ? traineeMal.length + 1
                            : traineeFem.length + 1,
                      },
                    },
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },
                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "right",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Trainee Adjudicators",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
              <div className="relative border flex align-items-center justify-content-center p-5">
                <BarChart
                  height="300px"
                  data={[
                    ["Male", adjMal.length],
                    ["Female", adjFem.length],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    scales: {
                      x: {
                        suggestedMax:
                          adjMal.length > adjFem.length
                            ? adjMal.length + 1
                            : adjFem.length + 1,
                      },
                    },
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },
                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "right",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Adjudicators",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
              <div className="relative border flex align-items-center justify-content-center p-5">
                <BarChart
                  height="300px"
                  data={[
                    ["Male", seniorMal.length],
                    ["Female", seniorFem.length],
                  ]}
                  colors={["rgba(239, 141, 35, 1)"]}
                  library={{
                    scales: {
                      x: {
                        suggestedMax:
                          seniorMal.length > seniorFem.length
                            ? seniorMal.length + 1
                            : seniorFem.length + 1,
                      },
                    },
                    datasets: {
                      bar: {
                        barThickness: 50,
                        maxBarThickness: 50,
                      },
                    },
                    plugins: {
                      datalabels: {
                        anchor: "end",
                        align: "right",
                        color: "#000",
                        font: {
                          weight: "bold",
                        },
                        formatter: (value) => `${value}`,
                      },
                      title: {
                        display: true,
                        text: "Senior Adjudicators",
                        font: {
                          size: 30,
                          weight: "bold",
                        },
                        padding: {
                          top: 10,
                          bottom: 50,
                        },
                      },
                    },
                    elements: {
                      arc: {
                        borderWidth: 0,
                      },
                    },
                  }}
                />
              </div>
            </div>
          </>
        )}
      </section>
      <DisputesFooter
        theme="dark"
        className="text-[#828282] bg-darkgray consulting-footer"
      />
    </div>
  );
};

export default Statistics;
